import React, { useEffect, useState } from 'react'
import post1 from "../../../assets/post1.png"
import post2 from "../../../assets/post2.png"
import post3 from "../../../assets/post3.png"
import post4 from "../../../assets/post4.png"
import post5 from "../../../assets/post5.png"
import post6 from "../../../assets/post6.png"
import post7 from "../../../assets/post7.png"
import post8 from "../../../assets/post8.png"
import post9 from "../../../assets/post9.png"
import post10 from "../../../assets/post10.png"
import { FiMoreVertical } from "react-icons/fi";
import arrowUp from '../../../assets/arrow_warm_up.png'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../loader/Loader'
import CreditContent from '../../recuiterDashboard/common/creditSection'
import PostNewJobPopup from './PostNewJobPopup'
import { closeJobPost, getJobPost } from '../../../services/operations/JobPostAPI'
import ConfirmationPopup from './ConfirmationPopup'


const JobPosting = () => {

  const [showPopup, setShowPopup] = useState(false);
  const [jobId, setJobId] = useState('');
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [count, setCounts] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [timeFilter, setTimeFilter] = useState("year");

  const loading = useSelector((state) => state.auth.loading)
  const token = useSelector((state) => state.auth.token)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlFilter = queryParams.get("filter") || "active";

  const [filter, setFilter] = useState(urlFilter);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlFilter = searchParams.get("filter");

    if (urlFilter) {
      setFilter(urlFilter);
    }
  }, [location.search]);


  const fetchJobs = async (page = 1) => {
    const params = { page };
    if (filter === 'active') params.is_active = true;
    if (filter === 'closed') params.is_close = true;
    if (filter === 'draft') params.is_draft = true;

    if (timeFilter === "year") params.year = true;
    if (timeFilter === "month") params.month = true;
    if (timeFilter === "week") params.week = true;

    setLoadData(true);
    const result = await dispatch(getJobPost(token, params));
    if (result?.data) {
      setLoadData(false);
      const { data, current_page, last_page, next_page_url, prev_page_url, counts } = result.data.data;

      setJobs(data);

      setCurrentPage(current_page);
      setTotalPages(last_page);
      setHasNextPage(!!next_page_url);
      setHasPrevPage(!!prev_page_url);
    }
    if (result?.data?.counts) {
      setCounts(result.data.counts)

    }
  };

  useEffect(() => {
    fetchJobs(currentPage);
  }, [currentPage, filter, timeFilter]);

  const handlePageChange = (newPage) => {
    if (!loadData && newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleFilterClick = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(1);
  };

  const handleTimeFilterChange = (event) => {
    setTimeFilter(event.target.value);
    setCurrentPage(1);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleRowClick = (id) => {
    const url = `/dashboard/jobpost-detail?id=${id}&filter=${filter}`;
    window.open(url, '_blank');
  };

  const handleCandidateClick = (job, type) => {
    const minimalData = {
      type: type,
      jobId: job.id,
      jobTitle: job.job_title,
      skills: job?.skills,
      niceToHaveSkills: job?.nice_to_have_skills,
      company: job?.company_name,
      industry: job?.industries,
      location: job?.job_location,
      experience: job?.experience,
    }
    console.log("puaaa", minimalData)

    // if (type === "Passive") {
    //   const encodedData = btoa(encodeURIComponent(JSON.stringify(minimalData)));
    //   const detailsURL = `/dashboard/relevant-candidates?data=${encodedData}`;
    //   window.open(detailsURL, '_blank');
    // }
    if (type === "Applicants") {
      const encodedData = btoa(encodeURIComponent(JSON.stringify(minimalData)));
      console.log("ddd", encodedData)
      const detailsURL = `/dashboard/relevant-applicants?data=${encodedData}`;
      window.open(detailsURL, '_blank');
    }
  };

  const handleClosePost = async (id) => {

    setConfirmPopup(true);
    setJobId(id);
    // const payload = {
    //   job_status: "CLOSED"
    // }
    // await dispatch(closeJobPost(payload, token, id))
    // setFilter(filter)
    // fetchJobs();
  }

  return (
    <>
      <CreditContent />
      {loading && <Loader />}
      <div className='jobpost-dashboard'>
        <div className='jobpost-uppar'>
          <div className='jobpost-first'>
            <div className='jobpost-container' style={{ position: "relative" }}>
              <img src={post1} alt='post1' className='postone' />
              <img src={post3} alt='post3' className='posttwo' />
              <img src={post4} alt='post4' className='postthree' />
              <img src={post5} alt='post5' className='postfour' />
              <img src={post6} alt='post6' className='postfive' />
              <img src={post7} alt='post7' className='postsix' />
              <img src={post8} alt='post8' className='postseven' />
              <img src={post9} alt='post9' className='posteigth' />
              <img src={post10} alt='post10' className='postnine' />
            </div>
            <p className='jobpost-first-heading'>Post to Hire your Ideal candidate!</p>
            <p className='jobpost-first-subheading'>Explore more than 80M+ profiles</p>
            <button className='jobpost-button' onClick={togglePopup}>Post New Job</button>

          </div>
          <div className='jobpost-second'>
            <p className='jobpost-second-heading'>Status</p>
            <div className='jobpost-controls'>
              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                <button
                  className={`jobpost-btn-active-btn ${filter === 'active' ? 'actives' : ''}`}
                  onClick={() => handleFilterClick('active')}
                >Active</button>
                <button
                  className={`jobpot-btn-close-btn ${filter === 'closed' ? 'actives' : ''}`}
                  onClick={() => handleFilterClick('closed')}
                >Closed</button>
                <button
                  className={`jobpot-btn-close-btn ${filter === 'draft' ? 'actives' : ''}`}
                  onClick={() => handleFilterClick('draft')}
                >Draft</button>
              </div>
              <select
                className='jobpost-dropdown'
                value={timeFilter}
                onChange={handleTimeFilterChange}
              >
                <option value="year">Year</option>
                <option value="month">Month</option>
                <option value="week">Week</option>
              </select>
            </div>

            <div className='jobpost-stats'>
              <div className='jobpost-box'>
                <div className='jobpost-content'>
                  <h3 className="jobpost-name">{count?.total}</h3>
                  <p className="jobpost-count">Job Posts</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
              <div className='jobpost-box'

              >
                <div className='jobpost-content'>
                  <h3 className="jobpost-name">{count?.applicants}</h3>
                  <p className="jobpost-count">Applicants</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
              <div className='jobpost-box'
              >
                <div className='jobpost-content'>
                  <h3 className="jobpost-name">{count?.shortlisted}</h3>
                  <p className="jobpost-count">Shortlisted</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
              <div className='jobpost-box'
              >
                <div className='jobpost-content'>
                  <h3 className="jobpost-name">{count?.hired}</h3>
                  <p className="jobpost-count">Hired</p>
                </div>
                <span className="navigate-icon">{">"}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='jobpost-lower'>
          <div className='jobpost-table-header'>
            <h3>
              {filter === "closed"
                ? "Previously Posted Jobs"
                : filter === "draft"
                  ? "Saved Draft"
                  : "Posted Jobs"}
            </h3>
          </div>

          <table className='jobpost-table'>

            <tbody>
              {loadData ?
                [...Array(5)].map((_, index) => (
                  <tr key={index}>
                    <td colSpan={"8"} style={{ padding: '20px' }}>
                      <div className="skeleton-row"></div>
                    </td>
                  </tr>
                )) :
                jobs.length > 0 ? (
                  jobs.map((job, index) => (
                    <tr
                      key={index}
                    >
                      <td className='jobpost-table-name'>
                        <img
                          src={job.profile_image ? job.profile_image : `https://api.dicebear.com/5.x/initials/svg?seed=${job.name}`}
                          alt='profile' style={{ width: "27px", height: "27px", borderRadius: "50%" }} />
                      </td>
                      <td className='jobpost-table-name' style={{ cursor: 'pointer', fontSize: "16px" }} onClick={() => handleRowClick(job.id)}>{job.job_title}</td>
                      <td style={{ fontWeight: "400" }}>{job.job_location}</td>
                      <td>
                        <button
                          className={`employment-type-btn ${job.workplace_type === "Remote"
                            ? "remote"
                            : job.workplace_type === "Onsite"
                              ? "onsite"
                              : "hybrid"
                            }`}
                        >
                          {job.workplace_type}
                        </button>
                      </td>
                      <td>{job.employment_type}</td>
                      <td>
                        {job?.experience && job.experience !== "N/A" ? (
                          (() => {
                            let parsed;

                            try {
                              if (typeof job.experience === "string") {
                                parsed = JSON.parse(job.experience);
                                parsed = Array.isArray(parsed) ? parsed : [parsed];
                              } else if (Array.isArray(job.experience)) {
                                parsed = job.experience;
                              } else {
                                parsed = [job.experience];
                              }
                            } catch (e) {
                              parsed = [job.experience];
                            }

                            return `${parsed.join(", ")} years`;
                          })()
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td style={{ fontWeight: "700" }}>
                        {job?.contract_price_per_hrs && job.contract_price_per_hrs !== "N/A"
                          ? `$${job.contract_price_per_hrs}/hr`
                          : job?.salary_range && job.salary_range !== "N/A"
                            ? job.salary_range
                            : "N/A"}
                      </td>
                      <td onClick={job?.applicant_count > 0 ? () => handleCandidateClick(job, "Applicants") : undefined}>
                        <button className='applicant-btn'
                          disabled={job?.applicant_count === 0}
                        >
                          <img src={arrowUp} alt="up" />
                          &nbsp;&nbsp;{job?.applicant_count} <span style={{ fontWeight: "700" }}>{job?.applicant_count <= 1 ? 'Applicant' : 'Applicants'}</span>
                        </button>
                      </td>
                      {/* <td onClick={job?.passivecandidate > 0 ? () => handleCandidateClick(job, "Passive") : undefined}>
                        <button
                          className='applicant-btn'
                          disabled={job?.passivecandidate === 0}
                          style={{minWidth:"140px"}}
                        >
                          {job?.passivecandidate} <span style={{fontWeight:"700"}}>{job?.passivecandidate <= 1 ? " Passive candidate" : " Passive candidates"}</span>
                        </button>
                      </td> */}
                      <td>
                        {job.job_status === "CLOSED" ? (
                          <button className='jobpost-close-btn' disabled>Closed</button>
                        ) : (
                          <button
                            className='jobpost-close-btn'
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClosePost(job.id);
                            }}
                          >
                            Close Post
                          </button>
                        )}
                      </td>

                    </tr>
                  ))
                ) :
                  (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>No jobs found</td>
                    </tr>)
              }
            </tbody>
          </table>
          {jobs?.length > 0 && (
            <div className='jobpost-pagination'>
              {currentPage !== 1 && (
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  className='jobpost-page-btn'
                  style={{ cursor: "pointer" }}
                >
                  Prev
                </button>
              )}

              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`jobpost-page-btn-count ${currentPage === index + 1 ? 'actives' : ''}`}
                  style={{
                    margin: '0 5px',
                    color: currentPage === index + 1 ? 'white' : 'rgba(122, 122, 122, 1)',
                    background: currentPage === index + 1 ? '#0002DC' : 'transparent',
                    cursor: 'pointer'
                  }}
                >
                  {index + 1}
                </button>
              ))}

              {currentPage !== totalPages && (
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  className='jobpost-page-btn'
                  style={{ cursor: "pointer" }}
                >
                  Next
                </button>
              )}
            </div>

          )}

        </div>
        {showPopup && <PostNewJobPopup onClose={() => setShowPopup(false)} fetchJobs={fetchJobs} />}
        {confirmPopup && <ConfirmationPopup onClose={() => setConfirmPopup(false)} id={jobId} fetchJobs={fetchJobs} filter={filter} setFilter={setFilter} />}
      </div>
    </>
  )
}

export default JobPosting